<template>
  <div>
    <small class="label">{{ $l.userPassword }}</small>
    <input
      type="password"
      class="input-text with-label"
      v-model="password"
      :placeholder="$l.userPassword"
      >
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ],

  computed: {
    password: {
      get: function () {
        return this.$store.state.user.password
      },

      set: function (password) {
        this.$store.commit('user/setPassword', password)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './_input.scss';
</style>
